/**
 * 站点配置（logo / 文案 / favicon / 登录背景等）
 *
 * 加载规则：按浏览器域名自动请求 static/siteConfig/<域名>/config.json，
 * 与默认配置合并后缓存到 window.siteConfig，并自动应用标题与 favicon。
 *
 * 目录结构：
 *   static/siteConfig/
 *     ├── mgt.imagingedu.com/
 *     │     ├── config.json
 *     │     ├── logo.png
 *     │     └── logo-small.png
 *     └── cmc.zpspark.com/
 *           ├── config.json
 *           └── ...
 */

// 默认配置（未命中域名文件夹时兜底）
const DEFAULT_CONFIG = {
  loginBack: 'static/images/bg.jpg',
  loginText: '医学影像高校教育平台',
  ico: '',
  title: '医学影像高校教育平台',
  showDownBtn: true,
  smalllogoUrl: 'static/images/logo-small.png',
  logoUrl: 'static/images/logo.png',
  logoText: '医学影像高校教育平台'
}

// 站点配置里需要按根路径处理的资源字段
const ASSET_KEYS = ['logoUrl', 'smalllogoUrl', 'loginBack', 'ico']

// 相对路径统一转为根路径，避免在深层路由下解析错误
const resolveAssetUrl = (path) => {
  if (!path) return path
  if (/^(https?:|data:|\/\/|\/)/i.test(path)) return path
  return '/' + path
}

// 站点配置地址：跟随浏览器域名（不含端口），如 static/siteConfig/mgt.imagingedu.com/config.json
export const getSiteConfigUrl = () => {
  return `static/siteConfig/${window.location.hostname}/config.json`
}

const fetchSiteConfig = () => {
  const xhr = new XMLHttpRequest()
  // 同步请求：保证登录页、侧边栏首次渲染即可取到配置
  xhr.open('GET', getSiteConfigUrl(), false)
  xhr.send(null)
  if (xhr.status === 200) {
    try {
      return JSON.parse(xhr.responseText) || {}
    } catch (error) {
      console.warn('siteConfig 解析失败，使用默认配置：', getSiteConfigUrl())
    }
  } else {
    console.warn('未找到站点配置，使用默认配置：', getSiteConfigUrl())
  }
  return {}
}

// 自动应用文档标题与站点图标
const applySiteConfig = (config) => {
  if (config.title) {
    document.title = config.title
  }
  if (config.ico) {
    let link = document.querySelector('link[rel="icon"]')
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = config.ico
  }
}

export const getInitConfig = () => {
  if (window.siteConfig) {
    return window.siteConfig
  }
  const config = Object.assign({}, DEFAULT_CONFIG, fetchSiteConfig())
  ASSET_KEYS.forEach(key => {
    config[key] = resolveAssetUrl(config[key])
  })
  applySiteConfig(config)
  window.siteConfig = config
  return config
}



// WEBPACK FOOTER //
// ./src/config/config.js